import Vue from 'vue'

import sinisterTransformer from './../../transformers/sinister/road'

export default (sinister) => {
  const payload = sinisterTransformer.send(sinister)
  return Vue.$http.post('sinisters/roads/', payload)
    .then((response) => {
      const data = sinisterTransformer.fetch(response.data)
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/sinister/createRoadSinister.js